/**
 * The owner daily report API client — the one analytics call that goes through a real contract parse
 * rather than the untyped passthrough the other analytics endpoints use, because this response is
 * per-player financial data and a shape drift should surface, not slip through.
 */
import { ownerDailyReportSchema, type OwnerDailyReport } from '@apuestapr/contracts';

import type { ApiClient, ApiResult } from '../api/client.ts';

export interface OwnerReportApi {
  readonly getDaily: (date: string) => Promise<ApiResult<OwnerDailyReport>>;
}

export const createOwnerReportApi = (client: ApiClient): OwnerReportApi => ({
  getDaily: (date) =>
    client.get(
      `/api/admin/analytics/owner-daily?date=${encodeURIComponent(date)}`,
      ownerDailyReportSchema,
    ),
});
